import cn from "classnames"
import { Suspense } from "react"

import { useEntityAI } from "@/api/useInventory"
import { Card, Flex, Segmented } from "@/atoms"
import { TABS as MAIN_TABS } from "@/organisms/Drawers/components/AgentAiDiscoveryDrawer/const"
import { useActiveTab } from "@/organisms/Drawers/components/AgentAiDiscoveryDrawer/hooks/useActiveTab"
import { TabTemplate } from "@/templates/TabTemplate/TabTemplate"

import overviewStyles from "../OverviewTabAgentAiDiscoveryDrawer/OverviewTabAgentAiDiscoveryDrawer.module.scss"
import styles from "./AiComponentsTabAgentAiDiscoveryDrawer.module.scss"

import type { AiComponentsTabTemplateProps } from "./AiComponentsTabAgentAiDiscoveryDrawer.types"

export const AiComponentsTabTemplate = (
  props: AiComponentsTabTemplateProps
) => {
  const {
    tabProps,
    entityType = "agent",
    tab,
    options,
    onTabChange,
    extra,
    renderGraph,
    children
  } = props
  const recordId = tabProps.record?.id

  const hierarchyCtx = useEntityAI(
    `${recordId}/hierarchy`,
    entityType,
    undefined,
    { enabled: !!recordId }
  )
  const { active } = useActiveTab(
    MAIN_TABS.aiComponents,
    hierarchyCtx.response?.data,
    tabProps
  )

  const classNameGraph = cn(
    "card-agent-ai-discovery-drawer",
    overviewStyles.card
  )

  return (
    <Flex
      vertical
      gap={24}
      className={cn("container-agent-ai-discovery-drawer", styles.container)}
    >
      <Suspense
        fallback={
          <Card loading className={classNameGraph} title="Hierarchy Graph" />
        }
      >
        <Card
          className={cn(
            classNameGraph,
            !hierarchyCtx.isLoading && overviewStyles.cardGraph
          )}
          title="Hierarchy Graph"
          extra={extra}
          loading={hierarchyCtx.isLoading}
        >
          <div className={styles.graph}>
            {recordId && active && renderGraph(recordId)}
          </div>
        </Card>
      </Suspense>
      <Flex vertical gap={16}>
        <span>
          <Segmented
            className={styles.segment}
            value={tab}
            options={options}
            onChange={onTabChange}
          />
        </span>
        <Suspense fallback={<TabTemplate sticky loading columns={[]} />}>
          {children}
        </Suspense>
      </Flex>
    </Flex>
  )
}
